import React from 'react';
import { Link } from 'react-router-dom';
import $ from "jquery";
import Header from '../modules/header'
import axios from 'axios';
import parse from 'html-react-parser';
import Slider from "react-slick";


import Footerslider from '../components/FooterSlider/footerslider';
import singleBlog1 from '../assets/images/yachts/mobile-blog-img1.png';
import singleBlog2 from '../assets/images/yachts/image-44.png';
import vectorblog1 from '../assets/images/Blog_single/wheel-vector.svg';
import singleBlog3 from '../assets/images/Blog_single/51-metre Dunia Baru.jpg';
import singleBlog4 from '../assets/images/yachts/mobile-blog-img2.png';
import singleBlog5 from '../assets/images/yachts/image-42.png';
import singleBlog6 from '../assets/images/Blog_single/Avatar Dunia Baru.jpg';
import blog6 from '../assets/images/yachts/image-42.png';
import vector3 from '../assets/images/Blog_single/fish-vector.svg';
import subblog1 from '../assets/images/Blog_single/Corsario.jpg';
import subblog2 from '../assets/images/Blog_single/Aresteas.jpg';
import subblog4 from '../assets/images/Blog_single/Pin.svg';
import arrow from '../assets/images/icons/button-arrow.svg';
import vector4 from '../assets/images/Blog_single/loadmore-wheel.svg';
import vtr1 from '../assets/images/Blog_single/Vector2.svg';
import vctr2 from '../assets/images/Blog_single/vector3.svg';
import Facebook from '../assets/images/Blog_single/Facebook.svg';
import Instagram from '../assets/images/Blog_single/Instagram.svg';
import Twitter from '../assets/images/Blog_single/Twitter.svg';
import Linkedin from '../assets/images/Blog_single/LinkedIn.svg';
import post_header from '../assets/images/Blog_single/Hero-bg.jpg';

class Blog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeSlide: 0,
            post: {},
            yachts: [],
            blog_content: {},
            next_page: 1,
            current_page: 0,
            general_content: {},
            SliderImages:[]
        };
        this.handlePagination = this.handlePagination.bind(this);

    }

    handlePagination(event) {
        this.loadData();
    }

    loadData() {
        const post_id = this.props.match.params.id;
        axios.get(`${process.env.REACT_APP_API_URL}/posts/${post_id}?page=${this.state.next_page}/.json`)
        .then((response) => {
            if(response.data.current_page === 1) {
                this.setState({ yachts: response.data.yachts })
            } else {
                this.setState({ 
                    yachts: this.state.yachts.concat(response.data.yachts)
                 })
            }

            this.setState({ 
                post: response.data.post,
                next_page: response.data.next_page,
                current_page: response.data.current_page,
            });

            if(response.data.post && response.data.post.images){
                let SliderImages = []
                response.data.post.images.map((image, index) => {
                    SliderImages.push(image.slider.url)
                })
               
                console.log('SliderImages', SliderImages)
                this.setState({SliderImages:SliderImages})
            }
        })
        .catch();
    }
    componentDidMount() {
        window.scrollTo(0, 0)

        this.loadData();

        axios.get(`${process.env.REACT_APP_API_URL}/content.json`)
        .then((response) => {
            this.setState({ general_content: response.data.general });
            window.scrollTo(0, 0)
        })
        .catch();

        axios.get(`${process.env.REACT_APP_API_URL}/content/blog.json`)
        .then((response) => {
            this.setState({ blog_content: response.data.blog.fields });
            window.scrollTo(0, 0)
        })
        .catch();
        
        $(".arrow-down a").on('click', function(event) {
            if (this.hash !== "") {
                event.preventDefault();
                var hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function() {
                    window.location.hash = hash;
                });
            }
        });
        // backto top jquery
        if ($('#back-to-top').length) {
            var scrollTrigger = 100, // px
                backToTop = function () {
                    var scrollTop = $(window).scrollTop();
                    if (scrollTop > scrollTrigger) {
                        $('#back-to-top').addClass('show');
                    } else {
                        $('#back-to-top').removeClass('show');
                    }
                };
            backToTop();
            $(window).on('scroll', function () {
                backToTop();
            });
            $('#back-to-top').on('click', function (e) {
                e.preventDefault();
                $('html,body').animate({
                    scrollTop: 0
                }, 700);
            });
        }
    }

    render() {
        const settings = {
            className: "center",
            // centerMode: true,
            infinite: true,
            swipeToSlide :true,
            // centerPadding: "0",
            slidesToShow: 2,
            speed: 500,
            slidesPerRow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            dots: true,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesPerRow: 1,
                        centerMode: false,
                        arrows: false
                    }
                }
            ],
            beforeChange: (current, next) => this.setState({oldSlide: current, activeSlide: next === -1 ? 0 : next}),
            afterChange: current => this.setState({activeSlide2: current})
        };
        const post = this.state.post;
        const yachts = this.state.yachts;

        const backgroundStyle = {
            backgroundImage: `url(${post && post.featured_image && post.featured_image.featured.url ? post.featured_image.featured.url : ''})`
        }

        return (
            <div className="open_menudiv">
                <Header></Header>
                {/* Main Hero Image section  */}

                <div className="hero-slider section singleblog-hero">
                    <div className="hero-item" id="singl_blog" style={backgroundStyle}>
                        <div className="slider-dark-overlay"></div>
                        <div className="container">
                            <div className="row">
                                <div className="hero-content-wrap col">
                                    <div className="hero-content singleblog-content">
                                        <div className="row">
                                            <div className="col">
                                                <div className="single-blog-details">
                                                    <p className="date">{post && new Date(post.created_at).getDate()} / {new Date(post.created_at).getMonth()} / {new Date(post.created_at).getFullYear()}</p>
                                                    <h1 className="name">{post && post.title}</h1>
                                                    <p className="details">{post && post.description && parse(post.description)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="arrow-down">
                            <a href="#singleblog-page">
                                <p className="scroll-text">Scroll Down</p>
                                <div className="arrow">
                                    <svg
                                        width="8"
                                        height="45"
                                        viewBox="0 0 8 45"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M3.64645 44.3536C3.84171 44.5488 4.15829 44.5488 4.35355 44.3536L7.53553 41.1716C7.7308 40.9763 7.7308 40.6597 7.53553 40.4645C7.34027 40.2692 7.02369 40.2692 6.82843 40.4645L4 43.2929L1.17157 40.4645C0.976311 40.2692 0.659728 40.2692 0.464466 40.4645C0.269204 40.6597 0.269204 40.9763 0.464466 41.1716L3.64645 44.3536ZM3.5 0.5L3.5 44H4.5L4.5 0.5L3.5 0.5Z"
                                            fill="white"/>
                                    </svg>

                                </div>
                            </a>
                        </div>
                        <div className="social-links-top">
                            <ul>
                                <li>
                                    <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.twitter_link}><img src={Twitter} className="img-responsive" alt="Twitter icon"/></a>
                                </li>
                                <li>
                                    <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.linkedin_link}><img src={Linkedin} className="img-responsive" alt="Linkedin icon"/></a>
                                </li>
                                <li>
                                    <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.instagram_link}><img src={Instagram} className="img-responsive" alt="Instagram icon"/></a>
                                </li>
                                <li>
                                    <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.facebook_link}><img src={Facebook} className="img-responsive" alt="Facebook icon"/></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Second section  */}
                <section id="singleblog-page" className="section fix singleblog-page wow slideInUp" data-wow-duration="1s">
                    {/* <div className="container-fluid">
                        <div className="row mt">
                            <div className="col-lg-6 col-md-6 no-padding">
                                <div className="single-blogpage-content">
                                    <div className="about-txt">
                                        <h1>Six go sailing: A family adventure on board Dunia Baru</h1>
                                        <p className="sub-txt">Seeking lifelong memories – and abundant childcare –
                                            Stewart Campbell sets sail with his brood on board 51-metre Dunia Baru in Raja
                                            Ampat.
                                        </p>
                                        <img src={singleBlog1} className="img-responsive mobile-shark-img" alt="singleBlog1" />
                                        <div className="img-description-mobile">
                                            <ul className="ul_mob_desc">
                                                <li>Swimming with the sharks in the Wayag Archipelago.</li>
                                            </ul>
                                        </div>
                                        <p className="shark_mobile">The shark cruised lazily into view, coasting just
                                            above the soft corals with a disarming lack of interest in the startled divers
                                            hovering nearby. We had been told an encounter with a blacktip was likely in the
                                            fauna-rich waters of Raja Ampat in Indonesia but still, it’s a shark. We’ve all
                                            seen Jaws. And this was only our second ever dive. Beside me, my 10-year-old
                                            daughter ashes the “OK” sign and we watch as the predator continues on its
                                            serene passage into the murky distance and out of sight. Years of culturally
                                            absorbed shark-fear disappear with it and we all start spinning around,
                                            desperate for another opportunity to swim within a few kicks of a toothy native.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 no-padding">
                                <div className="singleblog-img-right">
                                    <img src={singleBlog2} className="img-responsive" alt="singleBlog2" />
                                </div>

                                <div className="img-description">
                                    <ul>
                                        <li>Swimming with the sharks in the Wayag Archipelago.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="background-vector">
                        <img src={vectorblog1} className="img-responsive" alt="vector blog1" />
                    </div>
                    <div className="container">
                        
                        <div
                            className="row mtp wow slideInUp"
                            data-wow-duration="1s"
                            id="padding_mobtopbtm">
                            <div className="col-lg-12 col-md-12">
                                <p>
                                    { post && post.content && parse(post.content) }
                                </p>
                            </div>
                            
                        </div>
                        
                        {/* <div className="row wow slideInUp" data-wow-duration="1s">
                            <div className="large-image">
                                <img
                                    src={singleBlog3}
                                    className="img-responsive desktop-img"
                                    alt="51-metre Dunia Baru"/>
                            </div>
                            <div className="large-image-mobile">
                                <img
                                    src={singleBlog4}
                                    className="img-responsive mobile-ship-img" alt="51-metre"/>
                            </div>
                            <div className="img-description2">
                                <ul>
                                    <li>51-metre Dunia Baru is one of the finest phinisi yachts.</li>
                                </ul>
                            </div>

                        </div> */}

                        <div className="background-vector2">
                            <img src={vctr2} className="img-responsive" alt="vector2" />
                        </div>
                        {/* <div className="row mtp wow slideInUp" data-wow-duration="1s">
                            <div className="col-lg-6 col-md-6 padding-lr">
                                <div className="singleblog-img-right-mobile">
                                    <img
                                        src={singleBlog5}
                                        className="img-responsive raja-ampat-img" alt="singleBlog5" />
                                </div>
                                <div className="img-description-mobile">
                                    <ul>
                                        <li>Raja Ampat in all its glory</li>
                                    </ul>
                                </div>
                                <h2>In Raja Ampat, some islands jag up from the perfect sea...</h2>
                                <p>
                                    In Raja Ampat, some islands jag up from the perfect sea like giant stalagmites
                                    while others look as if they’ve been icked randomly across the seascape like
                                    paint from a brush. All are covered in deep emerald jungle. This is certainly
                                    the case in Misool, one of the four main islands in Raja Ampat, which we reach
                                    after an overnight passage from Sorong. Cruising down the narrow channel between
                                    the islands of Papua and Salawati the evening before, we had spied natural gas
                                    towers flaring over the rainforest canopy in the dimming light, but it is an
                                    entirely different industry – pearl farming – that seems to dominate in Misool .
                                    Ramshackle villages on stilts sit in the shallow waters, housing hundreds of
                                    workers who spend months at a time tending nearby oyster beds.
                                    <br/><br/>
                                    We stop at one of these villages briefly to pick up some guides for our first
                                    adventure – swimming through a vast cave structure called Tomolol. The cave
                                    mouth yawns open before us and the children are initially a little fearful about
                                    swimming into it, but clever Clive arms them with waterproof torches and soon
                                    they’re paddling forward. Around the first bend, the light vanishes completely
                                    and the ceiling is so far above us that the torch beams fail to reach the
                                    thousands of bats we can hear shuffling in the darkness. It’s like being in a
                                    giant sensory deprivation tank.
                                </p>

                                <div className="post-author">
                                    <div className="avatar">
                                        <img
                                            src={singleBlog6}
                                            className="img-responsive" alt="singleBlog6" />
                                    </div>
                                    <p className="desc">
                                        Dunia Baru is available to charter in Raja Ampat and Komodo with 37south yachts,
                                        from $13,500 per night.
                                    </p>
                                </div>

                            </div>
                            <div className="col-lg-6 col-md-6 padding-lr">
                                <div className="singleblog-img-right" id="single_blogimgone">
                                    <img src={blog6} className="img-responsive" alt="blog image3"/>
                                </div>
                                <div className="img-description2" id="mob_last_glory">
                                    <ul>
                                        <li>Raja Ampat in all its glory</li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}
                        <div className="row mtp article-footer">
                            <div className="col-lg-6 col-md-6 col-6">
                                <div className="published-date">
                                    <p>{post && new Date(post.created_at).getDate()} / {new Date(post.created_at).getMonth()} / {new Date(post.created_at).getFullYear()}</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-6" id="socl_mobspace">
                                <div className="social-share">
                                    <ul>
                                    <li>
                                        <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.twitter_link}><img src={Twitter} className="img-responsive" alt="Twitter icon"/></a>
                                    </li>
                                    <li>
                                        <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.linkedin_link}><img src={Linkedin} className="img-responsive" alt="Linkedin icon"/></a>
                                    </li>
                                    <li>
                                        <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.instagram_link}><img src={Instagram} className="img-responsive" alt="Instagram icon"/></a>
                                    </li>
                                    <li>
                                        <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.facebook_link}><img src={Facebook} className="img-responsive" alt="Facebook icon"/></a>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="background-vector3">
                        <img
                            src={vector3}
                            className="img-responsive" alt="vector"/>
                    </div>
                </section>

                <section id="destination-carousel" className="slider_desitnation">
                    <div className="container-fluid">
                        <div className="row desktop-slider">
                            {this.state.SliderImages.length>0?<div className="col-lg-12 col-md-12 no-padding singlepage-carousel">
                                <div>
                                <Slider {...settings}>
                                        {this.state.SliderImages.length>0?
                                        this.state.SliderImages.map((image, i)=>{
                                            return(
                                                <div>
                                                     <img key={i} src={image} className="img-responsive" alt="img responsive" />
                                                </div>
                                            )
                                        }):null
                                        }
                                    </Slider>
                                </div>
                                {
                                    post && post.images && post.images.length > 0
                                    ?
                                    <h4 className="desti_pagin desti_pagination">{this.state.activeSlide < 0 ? 1 : this.state.activeSlide + 1}  / { post && post.images && post.images.length}</h4>
                                    :
                                    false
                                }
                            </div>:null}
                        </div>

                    </div>
                </section>

                {/* Third Section  */}
                <section
                    id="other-gems"
                    className="section fix other-gems singl_bloggemg wow slideInUp"
                    data-wow-duration="1s">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="gems-content-div">
                                    { this.state && this.state.yachts && this.state.yachts.map((yacht, index) => {
                                        return [
                                            <div>
                                                { index === 0 ? 
                                                <div className="other-gems-cont-left">
                                                    <div className="heading">
                                                      <h1>{this.state.blog_content &&  this.state.blog_content.single_heading ? this.state.blog_content.single_heading : ''}</h1>
                                                      <p>{this.state.blog_content &&  this.state.blog_content.single_subheading ? this.state.blog_content.single_subheading : ''}</p>
                                                    </div>
                                                </div>
                                                    :
                                                    false
                                                }
                                                {
                                                    index % 2 === 0 ?
                                                    <div className="gems">
                                                        <div className="gems-img">
                                                            <Link to={`/yacht/${yacht.id}`}>
                                                                <img src={yacht && yacht.main_image.slider.url ? yacht.main_image.slider.url : subblog1} className="img-responsive" alt="subblog" />
                                                            </Link>
                                                        </div>
                                                        <div className="gems-content">
                                                            <Link to={`/yacht/${yacht.id}`}>
                                                                <p className="title">{yacht && yacht.name}</p>
                                                            </Link>
                                                            <div className="location">
                                                                <div className="icon">
                                                                    <img
                                                                        src={subblog4}
                                                                        className="img-responsive"
                                                                        alt="Map icon"/>
                                                                </div>
                                                                <p>{ yacht && yacht.sailing_countries && yacht.sailing_countries.map(e => e.name).join(", ") }</p>
                                                            </div>
                                                            <p className="txt">{yacht && yacht.about && parse(yacht.about.substr(0,200) + "...")}</p>
                                                        </div>
                                                    </div>
                                                    :
                                                    false
                                                }

                                        </div>
                                        ]
                                    })}
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6" id="remov_mobpadding">
                                <div className="gems-content-div">
                                { this.state && this.state.yachts && this.state.yachts.map((yacht, index) => {
                                    return [
                                        <div>
                                    {
                                            index % 2 !== 0 ?
                                    <div className="gems">
                                        <div className="gems-img">
                                            <Link to={`/yacht/${yacht.id}`}>
                                                <img src={yacht && yacht.main_image.slider.url ? yacht.main_image.slider.url : subblog1} className="img-responsive" alt="subblog" />
                                            </Link>
                                        </div>
                                        <div className="gems-content">
                                            <Link to={`/yacht/${yacht.id}`}>
                                                <p className="title">{yacht && yacht.name}</p>
                                            </Link>
                                            <div className="location">
                                                <div className="icon">
                                                    <img
                                                        src={subblog4}
                                                        className="img-responsive"
                                                        alt="Map icon"/>
                                                </div>
                                                <p>{ yacht && yacht.sailing_countries && yacht.sailing_countries.map(e => e.name).join(", ") }</p>
                                            </div>
                                            <p className="txt">{yacht && yacht.about && parse(yacht.about.substr(0,200) + "...")}</p>
                                        </div>
                                    </div>
                                    :
                                    false
                                }
                                {
                                            this.state.yachts.length === index + 1 && this.state.next_page !== null?

                                    <div className="load-moregems">
                                        <div className="gems-content">
                                            <p className="title">Load more
                                                <br/>luxury Gulets</p>
                                            <p className="txt">Go on... be curious</p>
                                            <button className="btn btn-secondary btn-theme" onClick={this.handlePagination}>
                                                <span>View more</span>
                                                <div className="button-arrow">
                                                    <img
                                                        src={arrow}
                                                        className="img-responsive"
                                                        alt="arrow"/>
                                                </div>
                                            </button>
                                        </div>
                                        <div className="vector-img">
                                            <img
                                                src={vector4}
                                                className="img-responsive"
                                                alt="arrow"/>
                                        </div>
                                    </div>
                                    :
                                    false
                                }
                                </div>

                                ]
                                })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="background-vector other-grms-vector">
                        <img src={vtr1} className="img-responsive" alt="Blog vector4"/>
                    </div>
                </section>

                {/* slider section */}
                <Footerslider></Footerslider>
                <a href="#pagetop" id="back-to-top" title="Back to top">&uarr;</a>

            </div>
        );
    }
}
export default Blog;